import { render, staticRenderFns } from "./BDXManagementTableFCPToggle.vue?vue&type=template&id=4486910e"
import script from "./BDXManagementTableFCPToggle.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFCPToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports